import React, { Component } from "react";
import { Card, Icon, Typography } from "antd";
import { MdCheckCircle } from "react-icons/md";
import "./FinalView.css";

const { Title } = Typography;

class BookingConfirmation extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <>
        <div className="final-view-container" style={{marginBottom:"20px"}}>
          <div className="no-result testR1">
            <Card style={{ height: "100%" }} className="no-result-card testR1">
            <div className="no-result-card-content">
              <div
                style={{
                  width: "100px",
                  height: "100px",
                  margin: "auto",
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                <Icon
                  type="check-circle"
                  theme="twoTone"
                  twoToneColor="#52c41a"
                  style={{ fontSize: "80px" }}
                />
              </div>
              <Title level={4} style={{ textAlign: "center" }}>
                Booking Confirmation
              </Title>
              <div
                style={{
                  fontSize: "18px",
                  color: "#43637c",
                  textAlign: "center",
                  width: "100%",
                  height: "auto",
                  marginBottom: "20px",
                  marginTop: 0,
                  margin: "auto",
                }}
              >
                <p>Booking ID : {this.props.bookingId}</p>
                <p>Your booking details have been saved successfully.</p>
                {this.props.rfq && !this.props.rfq.error && (
                  <p style={{ marginTop: 12 }}>
                    RFQ #{this.props.rfq.id} created for additional services
                    {this.props.rfq.sections && this.props.rfq.sections.length
                      ? ` (${this.props.rfq.sections.join(', ')})`
                      : ''}
                    {' '}— status {this.props.rfq.status}.
                  </p>
                )}
                {this.props.rfq && this.props.rfq.error && (
                  <p style={{ marginTop: 12, color: '#cf1322' }}>
                    Additional-services RFQ could not be sent (orchestrator unreachable).
                  </p>
                )}
              </div>
              </div>
            </Card>
          </div>
        </div>
      </>
    );
  }
}

export default BookingConfirmation;
